import vanFr from './beer_van_fr.png';
import vanEn from './beer_van_en.png';
import edmFr from './beer_edm_fr.png';
import edmEn from './beer_edm_en.png';
import monFr from './beer_mon_fr.png';
import monEn from './beer_mon_en.png';
import ottFr from './beer_ott_fr.png';
import ottEn from './beer_ott_en.png';
import torFr from './beer_tor_fr.png';
import torEn from './beer_tor_en.png';

export const fr = {
    van: vanFr,
    edm: edmFr,
    mon: monFr,
    ott: ottFr,
    tor: torFr
};

export const en = {
    van: vanEn,
    edm: edmEn,
    mon: monEn,
    ott: ottEn,
    tor: torEn
};
